import { useState } from "react";
import { api, ApiError } from "../lib/api";

export default function PasswordGate({ onUnlock }: { onUnlock: () => void }) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setErr(null);
    try {
      await api.login(password);
      onUnlock();
    } catch (e) {
      setErr(e instanceof ApiError && e.status === 401 ? "Невірний пароль" : "Помилка входу");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="center-screen">
      <form className="card pad" style={{ width: 360 }} onSubmit={submit}>
        <div className="brand" style={{ padding: "0 0 14px" }}>
          <div className="logo">K</div>
          <div>
            <div className="name">Kidden Video Studio</div>
            <div className="sub">Video creative tool</div>
          </div>
        </div>
        <div className="field">
          <label>Пароль</label>
          <input
            className="input"
            type="password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
          {err && <div className="hint" style={{ color: "var(--red)" }}>{err}</div>}
        </div>
        <button className="btn primary" style={{ width: "100%" }} disabled={busy || !password}>
          {busy ? <span className="spinner" /> : "Увійти"}
        </button>
      </form>
    </div>
  );
}
